import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
// import RLDD from "react-list-drag-and-drop/lib/RLDD";
import {Alert} from "react-bootstrap";
import Error from "../../Utils/Error";

class EditPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editorState: EditorState.createEmpty(),
            editorState2: EditorState.createEmpty(),
            pageId: null,
            pageSlug: null,
            title: '',
            content1: null,
            content2: null,
            incorrect: false,
            error: 'title or content1 incorrect. Please try again.',
            loading: true,
            loadError: "",
            hasContent2: false,
            faqs: [],
            success: false,
            titleDescription: '',
            errors: {}
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSaveFaqs = this.handleSaveFaqs.bind(this);
        this.handleChangeValue = this.handleChangeValue.bind(this);
        this.handleRLDDChange = this.handleRLDDChange.bind(this);
        this.handleChangeTitleDescription = this.handleChangeTitleDescription.bind(this);

        this.onChange = editorState => {
            this.setState({
                content1: draftToHtml(convertToRaw(editorState.getCurrentContent())),
                editorState
            })
        };

        this.onChange2 = editorState2 => {
            this.setState({
                content2: draftToHtml(convertToRaw(editorState2.getCurrentContent())),
                editorState2
            })
        };
    }

    loadData() {
        this.setState({ loading: true });

        let pageId = this.props.match.params.id;
        this.setState({ pageId });

        const headers = {
            'Content-Type': 'application/json'
        };

        return axios
            .get(`/api/pages/${pageId}`, headers)
            .then(response => {
                let data = response.data.data;
                if(data.slug === 'faqs'){
                    this.setState({
                        pageSlug : 'faqs',
                        titleDescription: data.content1,
                        faqs : JSON.parse(data.content2),
                    })
                }

                const blocksFromHtml = htmlToDraft(data.content1);
                const { contentBlocks, entityMap } = blocksFromHtml;
                const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);

                let blocksFromHtml2;
                let contentState2;

                if(data.name === "About" && data.content2){
                    blocksFromHtml2 = htmlToDraft(data.content2);
                    const { contentBlocks, entityMap } = blocksFromHtml2;
                    contentState2 = ContentState.createFromBlockArray(contentBlocks, entityMap);
                }

                this.setState({
                    title: data.title,
                    content1: data.content1,
                    content2: data.content2,
                    loading: false,
                    loadError: false,
                    editorState: EditorState.createWithContent(contentState),
                    editorState2: (contentState2) ? EditorState.createWithContent(contentState2) : null
                });

            })
            .catch((error) => {
                this.setState({
                    loading: false,
                    loadError: `${error}`
                });
            });
    }

    componentDidMount() {
        this.loadData();
        this.setState({ incorrect: false });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    async handleSaveFaqs() {
        try {
            const data = {
                title: "Faqs",
                content1: this.state.titleDescription,
                content2: JSON.stringify(this.state.faqs)
            }
            await axios.put(`/api/pages/${this.state.pageId}`, data);
            this.setState({ success: true });
            this.setState({ errors: {} });
        } catch (e) {
            this.setState({ errors: e });
        }
    }

    handleChangeValue(categoryId, value, itemId = null, type){
        let faqs = this.state.faqs;
        if(itemId){
            const categoryIndex = faqs.findIndex(x => x.id == categoryId);
            let category = faqs[categoryIndex];
            const itemIndex = category.items.findIndex(x => x.id == itemId);
            let faq = category.items[itemIndex];
            faq[type] = value
            category.items[itemIndex] = faq
            faqs[categoryIndex] = category;
        } else {
            const categoryIndex = faqs.findIndex(x => x.id == categoryId);
            let category = faqs[categoryIndex];
            category.title = value
            faqs[categoryIndex] = category;
        }
        this.setState({ faqs })
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({ incorrect: false });
        // TODO CSRF validation currently disabled in Kernel.php

        const headers = {
            'X-CSRF-TOKEN': window.Laravel.csrfToken,
            'X-Requested-With': 'XMLHttpRequest'
        };

        axios
            .put(`/api/pages/${this.state.pageId}`, this.state, headers)
            .then(response => {
                this.props.history.push(`/admin/dashboard/pages`);
            })
            .catch(err => {
                let errors = Object.values(err.response.data.data);
                this.setState({ incorrect: true, error: errors });
            });

        return false;
    }

    handleRLDDChange(reorderedItems) {
        this.setState({ faqs: reorderedItems });
    }

    handleChangeTitleDescription(value) {
        this.setState({ titleDescription: value });
    }

    render() {

        const { loading, loadError, title, content1, content2, error, incorrect } = this.state;
        if(this.state.pageSlug == 'faqs'){
            return <EditFaqsPage
                content={this.state.faqs}
                handleRLDDChange={this.handleRLDDChange}
                handleSaveFaqs={this.handleSaveFaqs}
                pageId={this.state.pageId}
                success={this.state.success}
                handleChangeTitleDescription={this.handleChangeTitleDescription}
                titleDescription={this.state.titleDescription}
                errors={this.state.errors}
            />
        }

        let content1Label = "Content"
        let content2Input = "";
        let toolbar = {
            options: ['inline', 'blockType', 'fontSize', 'list', 'colorPicker', 'link', 'emoji', 'image', 'remove', 'history'],
            inline: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript']
            },
            blockType: {
                inDropdown: true,
                options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote', 'Code'],
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
            },
            fontSize: {
                options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
            },
            list: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: ['unordered', 'ordered', 'indent', 'outdent'],
            },
            textAlign: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: ['left', 'center', 'right', 'justify'],
            },
            colorPicker: {
                className: undefined,
                component: undefined,
                popupClassName: undefined,
                colors: ['rgb(97,189,109)', 'rgb(26,188,156)', 'rgb(84,172,210)', 'rgb(44,130,201)',
                    'rgb(147,101,184)', 'rgb(71,85,119)', 'rgb(204,204,204)', 'rgb(65,168,95)', 'rgb(0,168,133)',
                    'rgb(61,142,185)', 'rgb(41,105,176)', 'rgb(85,57,130)', 'rgb(40,50,78)', 'rgb(0,0,0)',
                    'rgb(247,218,100)', 'rgb(251,160,38)', 'rgb(235,107,86)', 'rgb(226,80,65)', 'rgb(163,143,132)',
                    'rgb(239,239,239)', 'rgb(255,255,255)', 'rgb(250,197,28)', 'rgb(243,121,52)', 'rgb(209,72,65)',
                    'rgb(184,49,47)', 'rgb(124,112,107)', 'rgb(209,213,216)'],
            },
            link: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                popupClassName: undefined,
                dropdownClassName: undefined,
                showOpenOptionOnHover: true,
                defaultTargetOption: '_self',
                options: ['link', 'unlink'],
                linkCallback: undefined
            },
            emoji: {
                className: undefined,
                component: undefined,
                popupClassName: undefined,
                emojis: [
                    '😀', '😁', '😂', '😃', '😉', '😋', '😎', '😍', '😗', '🤗', '🤔', '😣', '😫', '😴', '😌', '🤓',
                    '😛', '😜', '😠', '😇', '😷', '😈', '👻', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '🙈',
                    '🙉', '🙊', '👼', '👮', '🕵', '💂', '👳', '🎅', '👸', '👰', '👲', '🙍', '🙇', '🚶', '🏃', '💃',
                    '⛷', '🏂', '🏌', '🏄', '🚣', '🏊', '⛹', '🏋', '🚴', '👫', '💪', '👈', '👉', '👉', '👆', '🖕',
                    '👇', '🖖', '🤘', '🖐', '👌', '👍', '👎', '✊', '👊', '👏', '🙌', '🙏', '🐵', '🐶', '🐇', '🐥',
                    '🐸', '🐌', '🐛', '🐜', '🐝', '🍉', '🍄', '🍔', '🍤', '🍨', '🍪', '🎂', '🍰', '🍾', '🍷', '🍸',
                    '🍺', '🌍', '🚑', '⏰', '🌙', '🌝', '🌞', '⭐', '🌟', '🌠', '🌨', '🌩', '⛄', '🔥', '🎄', '🎈',
                    '🎉', '🎊', '🎁', '🎗', '🏀', '🏈', '🎲', '🔇', '🔈', '📣', '🔔', '🎵', '🎷', '💰', '🖊', '📅',
                    '✅', '❎', '💯',
                ],
            },
            image: {
                className: undefined,
                component: undefined,
                popupClassName: undefined,
                urlEnabled: true,
                uploadEnabled: true,
                alignmentEnabled: true,
                uploadCallback: undefined,
                previewImage: false,
                inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                alt: { present: false, mandatory: false },
                defaultSize: {
                    height: 'auto',
                    width: 'auto',
                },
            },
            history: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: ['undo', 'redo'],
            },
        }

        if(content2){
            content1Label = "Content next to image"
            content2Input = (<div className="col-12  form-group">
                <label>Content below image</label>
                <Editor
                    editorState={this.state.editorState2}
                    onEditorStateChange={this.onChange2}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editorClassName"
                    toolbar={toolbar}
                />
            </div>);
        }

        if (loadError) {
            return "ERROR";
        }
        else if (loading) {
            return "LOADING..."
        }
        else {

            return (
                <section className="contact-wrapper">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8">
                                <div className="contact_form">
                                    <h3 className="title">Edit Page
                                    </h3>

                                    <div id="login">
                                        <div id="message" />
                                        <form
                                            method="post"
                                            action=""
                                            onSubmit={this.handleSubmit}>
                                            <input
                                                type="hidden"
                                                name="csrf-token"
                                                value={window.Laravel.csrfToken}
                                            />

                                            <div className="row">
                                                <div className="col-12  form-group">
                                                    <label>Title</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Post title"
                                                        name="title"
                                                        id="title"
                                                        required
                                                        value={title}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </div>

                                                <div className="col-12  form-group">
                                                    <label>{content1Label}</label>
                                                    <Editor
                                                        editorState={this.state.editorState}
                                                        onEditorStateChange={this.onChange}
                                                        toolbarClassName="toolbarClassName"
                                                        wrapperClassName="wrapperClassName"
                                                        editorClassName="editorClassName"
                                                        toolbar={toolbar}
                                                    />
                                                </div>
                                                {content2Input}
                                                <div className="col-12 form-group" style={{'visibility': incorrect ? 'visible' : 'hidden'}}>
                                                    <label style={{'color': 'red'}}>{error}</label>
                                                </div>
                                                <div className="submit-btn mt-0">
                                                    <input
                                                        className="btn btn-primary"
                                                        value="Submit"
                                                        type="submit"
                                                        name="submit"
                                                        id="submit"
                                                    />
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            );
        }
    }
}

const EditFaqsPage = (props) => {
    const { content, handleRLDDChange, handleSaveFaqs, pageId, success, titleDescription, handleChangeTitleDescription, errors } = props;
    return (
        <section className="contact-wrapper">
            <div className="container">
                {
                    success && <Alert variant="success">Content updated successfully</Alert>
                }
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="contact_form">
                            <h3 className="title">Edit FAQ's page</h3>
                            <div className="container">
                                <h4>Title description</h4>
                                <div className="form-group">
                                    <textarea
                                        className="form-control"
                                        placeholder="Answer"
                                        required
                                        rows="10"
                                        value={titleDescription}
                                        onChange={(e) => handleChangeTitleDescription(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="container pt-4">
                                <h4>Drag and drop to order FAQ's groups</h4>
                                <div className="row">
                                    <div className="col-1">#</div>
                                    <div className="col-10">Category</div>
                                    <div className="col-1">Action</div>
                                </div>
                                {/*
                                <RLDD
                                    items={content}
                                    itemRenderer={(item, index) => {
                                        return (
                                            <div className="card my-2 py-2 px-2" style={{ width: "100%"}}>
                                                <div className="row">
                                                    <div className="col-1">{ index + 1 }</div>
                                                    <div className="col-3">
                                                        { item.title }
                                                    </div>
                                                    <div className="col-5">
                                                        { item.a }
                                                    </div>
                                                    <div className="col-3 d-flex">
                                                        <Link to={`/admin/dashboard/pages/${pageId}/${item.id}/title/edit`}>
                                                            <button
                                                                className="btn btn-primary btn-sm mr-2"
                                                            ><i className="fa fa-pencil-alt"></i> Edit title</button>
                                                        </Link>
                                                        <Link to={`/admin/dashboard/pages/${pageId}/${item.id}`}>
                                                            <button
                                                                className="btn btn-primary btn-sm"
                                                            ><i className="fa fa-pencil-alt"></i> Edit content</button>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }}
                                    onChange={handleRLDDChange}
                                />
                                */}
                                <Error error={errors}/>
                                <div className="submit-btn mt-3">
                                    <input
                                        id="submit"
                                        className="btn btn-block btn-primary float-right"
                                        value="Save changes"
                                        type="button"
                                        name="submit"
                                        onClick={handleSaveFaqs}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default withRouter(EditPage);
